"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * base class for a JBrowse plugin
 */
class Plugin {
    constructor() {
        this.configurationSchema = undefined;
    }
    install(_pluginManager) { }
    configure(_pluginManager) { }
}
exports.default = Plugin;
